// All constant and reusable variables that define important data

// Uppercase is used because it's a constant that will never change. So it's kind of a common practice specially in a configuration file like this.
export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = 'b754bc93-bc46-4e32-bb56-b12c1956aa59';
export const MODAL_CLOSE_SEC = 2.5;
export const ADD_RECIPE_RERENDER_SEC = 3;
